import { useParams } from 'react-router';
import { useMe } from './session';

export const ALL = 'all';
const LAST_KEY = 'wd-last-business';

export type BizRef = { id: string; name: string; slug: string; memberRole?: 'owner' | 'member' | null };

/** The client's current business from the `/b/:slug` route. `business` is null for "All businesses". */
export function useClientBusiness() {
  const me = useMe();
  const { slug = '' } = useParams();
  const businesses: BizRef[] = me.businesses;
  const business = slug === ALL ? null : (businesses.find((b) => b.slug === slug) ?? null);
  const valid = slug === ALL ? businesses.length > 1 : !!business;
  return { me, slug, business, businesses, isAll: slug === ALL, valid, scopeId: business?.id ?? ALL };
}

export function rememberBusiness(userId: string, slug: string) {
  try {
    localStorage.setItem(`${LAST_KEY}:${userId}`, slug);
  } catch {
    /* ignore */
  }
}

export function lastBusiness(userId: string): string | null {
  try {
    return localStorage.getItem(`${LAST_KEY}:${userId}`);
  } catch {
    return null;
  }
}

/** Default landing slug for a client: remembered, else "all" when > 1, else their only business. */
export function defaultSlug(me: { id: string; businesses: BizRef[] }): string | null {
  const last = lastBusiness(me.id);
  if (last && (last === ALL ? me.businesses.length > 1 : me.businesses.some((b) => b.slug === last))) return last;
  if (me.businesses.length > 1) return ALL;
  return me.businesses[0]?.slug ?? null;
}
